export default __webpack_public_path__ + "static/media/magiccity2.6d2574f9.jpeg";